module.exports = __webpack_public_path__ + "img/2b92258.jpg";